export default __webpack_public_path__ + "static/0218-1ee26877a0bb97b474d95f4e6e20cea3.png";